// extracted by mini-css-extract-plugin
module.exports = {"load_wrapper":"Loader_load_wrapper___FFJd","lds_ring":"Loader_lds_ring__5BB87","lds-ring":"Loader_lds-ring__hDdjF"};